import { __assign, __spreadArrays } from "tslib";
import React, { useEffect, useState } from 'react';
import { SolutionInfo, dtoToInfoProps, } from './solution-info';
import s from './solution-page.scss';
import { SolutionOverView, dtoToOverViewProps, } from './solution-overview/solution-overview';
import { SolutionRateReviewsContainer } from './solution-rate-and-reviews/solution-rate-reviews-container';
import { SolutionsGridContainer, dtoToGridsSolutions, } from '../solution-page-views/solutions-grid/solutions-grid-container';
import { SolutionPlans, dtoToSolutionPlansProps, } from './solution-plans';
import { AppPageMode } from '../../..';
import { ReviewsPreivewWrapper, SuggestionPreviewWrapper, PlansPreivewWrapper, } from '../preview-elements/';
import { dtoToBreadcrumbsSectionProps, SolutionBreadcrumbsSection, } from '../../breadcrumbs-section/solution-breadcrumbs-section';
import { Row, Col, Divider, SectionHelper, Text, TextButton, Box } from 'wix-style-react';
import { FluidContainer } from '../../FluidContainer';
import { useConfigContext } from '../../../config-context';
import { composer } from '../../../component-decorators/composer';
import { isBundleAppAndInstalled } from '../../../common/utils';
import { biLogger } from '../../../bi';
import { VisibilityDetector } from '../../visibility-detector/visibility-detector';
import { getReferralInfo, sendAppPageImpressionsBi, } from '../../../common/bi-events';
import { BackButton } from '../../back-button';
import { isAppSetupIncomplete } from '../../../common/is-app-setup-incomplete';
import { config } from '../../../config';
export var dtoToSolutionPageProps = function (solutionDto, prevRoute, mode) {
    return {
        appName: solutionDto.baseInfo.name,
        solutionId: solutionDto.baseInfo.id,
        solutionDeveloperIcon: solutionDto.baseInfo.icon,
        developerName: solutionDto.baseInfo.company
            ? solutionDto.baseInfo.company.name
            : 'Dev Name',
        solutionOverViewProps: dtoToOverViewProps(solutionDto),
        solutionInfoProps: dtoToInfoProps(solutionDto),
        solutionPlansProps: dtoToSolutionPlansProps(solutionDto, mode),
        solutionsGridProps: dtoToGridsSolutions(solutionDto),
        solutionBreadcrumbsSectionProps: dtoToBreadcrumbsSectionProps(solutionDto, prevRoute)
    };
};
export var SolutionPage = composer()
    .withMarketplaceStore()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var _b, _c;
    var solutionId = _a.solutionId, developerName = _a.developerName, solutionDeveloperIcon = _a.solutionDeveloperIcon, solutionInfoProps = _a.solutionInfoProps, solutionOverViewProps = _a.solutionOverViewProps, solutionPlansProps = _a.solutionPlansProps, solutionsGridProps = _a.solutionsGridProps, solutionBreadcrumbsSectionProps = _a.solutionBreadcrumbsSectionProps, mode = _a.mode, t = _a.t, marketplaceStore = _a.marketplaceStore, experiments = _a.experiments;
    // tslint:disable: react-hooks-nesting
    var _d = useConfigContext(), locale = _d.locale, countryCode = _d.countryCode, openPackagePicker = _d.openPackagePicker, isMobile = _d.isMobile, getAppInstance = _d.getAppInstance;
    // tslint:disable-next-line: react-hooks-nesting
    var _e = useState(isBundleAppAndInstalled(solutionId, marketplaceStore.bundleApps)), showBundleHelper = _e[0], setShowBundleHelper = _e[1];
    // tslint:disable-next-line:react-hooks-nesting
    var _f = useState([]), sectionsWithBi = _f[0], setSectionsWithBi = _f[1];
    // tslint:disable-next-line: react-hooks-nesting
    useEffect(function () {
        if (showBundleHelper) {
            // tslint:disable-next-line: no-floating-promises
            biLogger.appMarketToastPresented({
                action_cta: 'open_package_picker',
                app_id: solutionId,
            });
        }
    }, [showBundleHelper]);
    var onSectionImpression = function (sectionName, sectionIndex) {
        if (!sectionsWithBi.includes(sectionName)) {
            // tslint:disable-next-line:no-shadowed-variable
            setSectionsWithBi(function (sectionsWithBi) { return __spreadArrays(sectionsWithBi, [sectionName]); });
            sendAppPageImpressionsBi(sectionName, sectionIndex, solutionId);
        }
    };
    var showBackButton = marketplaceStore.prevRoute &&
        marketplaceStore.route.referral !== 'menu_navigation' &&
        marketplaceStore.route.referral !== 'back_button';
    var currentApp = (_b = marketplaceStore.installedApps) === null || _b === void 0 ? void 0 : _b.find(function (installedApp) { return installedApp.webSolutionBase.id === solutionId; });
    var shouldDisplayIncompleteSetupNotice = isAppSetupIncomplete(currentApp, experiments);
    var appInstallationData = {
        appDefId: solutionId,
        isPremiumApp: false,
        openMethod: (_c = currentApp === null || currentApp === void 0 ? void 0 : currentApp.webSolutionBase) === null || _c === void 0 ? void 0 : _c.openConsentIn,
        version: marketplaceStore === null || marketplaceStore === void 0 ? void 0 : marketplaceStore.route.version,
    };
    return (React.createElement(FluidContainer, { vocab: "https://schema.org/", typeof: "SoftwareApplication" },
        React.createElement(Row, null,
            React.createElement(Col, { className: showBackButton ? s.breadcrumbsWithBack : s.breadcrumbs },
                React.createElement(Box, { direction: isMobile ? 'vertical' : 'horizontal', verticalAlign: 'middle' },
                    showBackButton && (React.createElement(BackButton, { appId: solutionId, skinColor: 'standard', inSolutionPage: true })),
                    !isMobile && React.createElement(SolutionBreadcrumbsSection, __assign({}, solutionBreadcrumbsSectionProps))))),
        showBundleHelper && (React.createElement(Row, { className: s.bundleHelper },
            React.createElement(Col, null,
                React.createElement(SectionHelper, { actionText: t('solution.page.bundleHelper.cta'), appearance: "standard", onAction: function () {
                        var _a;
                        biLogger.appMarketToastClickOnCta({
                            action_cta: 'open_package_picker',
                            app_id: solutionId,
                        });
                        openPackagePicker(marketplaceStore.installedApps && ((_a = marketplaceStore.installedApps) === null || _a === void 0 ? void 0 : _a.find(function (app) { return app.webSolutionBase.id === solutionId; })), 'solution_page_bundle_apps', true);
                    }, onClose: function () {
                        biLogger.appMarketToastClosedX({
                            action_cta: 'open_package_picker',
                            app_id: solutionId,
                        });
                        setShowBundleHelper(false);
                    }, fullWidth: true, title: React.createElement(Text, { size: "small", weight: "bold" }, t('solution.page.bundleHelper.title')) },
                    React.createElement(Text, { size: 'small' }, t('solution.page.bundleHelper.subtitle', {
                        appName: solutionInfoProps.solutionDetailsProps.name,
                    })),
                    React.createElement(TextButton, { as: "a", dataHook: 'learn-more-bundle', size: "small", target: "_blank", underline: "always", skin: "dark", href: t('solution.page.bundleHelper.subtitle.article.url') }, t('solution.page.bundleHelper.subtitle.article.anchor')))))),
        shouldDisplayIncompleteSetupNotice && (React.createElement(Row, null,
            React.createElement(Col, { span: 12 },
                React.createElement(SectionHelper, { appearance: "warning", title: t('solution.page.incompleteSetupHelper.title'), actionText: t('solution.page.incompleteSetupHelper.actionButtonText'), onAction: function () {
                        var _a;
                        biLogger.appMarketClickOnCompleteSetup({
                            app_id: solutionId,
                            referral_info: getReferralInfo((_a = marketplaceStore.route) === null || _a === void 0 ? void 0 : _a.referral, marketplaceStore.prevRoute),
                        });
                        config.installApp(appInstallationData);
                    } }, t('solution.page.incompleteSetupHelper.content'))))),
        React.createElement(Row, null,
            React.createElement(Col, { span: 12 },
                React.createElement(SolutionInfo, __assign({}, solutionInfoProps)),
                React.createElement("div", { className: s.infoDivider },
                    React.createElement(Divider, null)))),
        React.createElement(Row, null,
            React.createElement(Col, { span: 12 },
                React.createElement(VisibilityDetector, { onVisible: function () { return onSectionImpression('SolutionOverview', 1); }, onUnVisible: function () {
                        return '';
                    } },
                    React.createElement(SolutionOverView, __assign({}, solutionOverViewProps)),
                    React.createElement(Divider, null)))),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(VisibilityDetector, { onVisible: function () { return onSectionImpression('SolutionReviews', 2); }, onUnVisible: function () {
                        return '';
                    } },
                    React.createElement(ReviewsPreivewWrapper, null,
                        React.createElement(SolutionRateReviewsContainer, { appName: solutionInfoProps.solutionDetailsProps.name, developerName: developerName, solutionId: solutionId, developerIcon: solutionDeveloperIcon, showEmptyState: mode === AppPageMode.TEST, isMobile: isMobile }))))),
        React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(VisibilityDetector, { onVisible: function () { return onSectionImpression('SolutionPricingPlans', 3); }, onUnVisible: function () {
                        return '';
                    } },
                    React.createElement(PlansPreivewWrapper, __assign({}, solutionPlansProps),
                        React.createElement(SolutionPlans, __assign({}, solutionPlansProps)))))),
        React.createElement(Row, null, mode !== AppPageMode.TEST && (React.createElement(Col, null,
            React.createElement(VisibilityDetector, { onVisible: function () {
                    return onSectionImpression('SolutionRelatedApps', 4);
                }, onUnVisible: function () {
                    return '';
                } },
                React.createElement("div", { className: s.suggestionDivider },
                    React.createElement(Divider, null)),
                React.createElement(SuggestionPreviewWrapper, null,
                    React.createElement(SolutionsGridContainer, __assign({}, solutionsGridProps, { locale: locale, countryCode: countryCode, getAppInstance: getAppInstance })))))))));
});
//# sourceMappingURL=solution-page.js.map